import { hasErrorCode } from '@/core/api';
import ERROR_CODES from '@/core/apiErrorCodes';
import { getDefaultErrorMessage } from '@/core/apiErrorMessages';

// Maps the team-join `requestToJoinGroup` error to a code/message pair the
// step components can render. Each known GROUP_* code gets dedicated copy so
// the user sees why their request failed; unknown errors fall back to a
// generic banner with the raw message.
export function mapTeamJoinError(err: unknown): { code: string; message: string } {
  const knownCodes = [
    ERROR_CODES.GROUP_ALREADY_MEMBER_OR_PENDING,
    ERROR_CODES.GROUP_EMAIL_DOMAIN_MISMATCH,
    ERROR_CODES.GROUP_NOT_JOINABLE,
  ];
  for (const code of knownCodes) {
    if (hasErrorCode(err, code)) {
      return { code, message: getDefaultErrorMessage(code) ?? 'Unable to request access.' };
    }
  }
  // Fallback for anything that isn't a recognized GROUP_* code (network
  // error, server 500, etc.). Surfacing GROUP_NOT_JOINABLE here would
  // mislabel unrelated failures in analytics + branching UI.
  return {
    code: ERROR_CODES.UNKNOWN,
    message: err instanceof Error ? err.message : 'Failed to request access',
  };
}
